import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

export default function DialogError(props) {
    const {openDialogError, setOpenDialogError} = props
  const [open, setOpen] = React.useState(false);


  return (
    <div>
      <Dialog
        open={openDialogError}
        onClose={()=>setOpenDialogError(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
            Login Failed
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Username/Password is incorrect
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={()=>setOpenDialogError(false)}>OK</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
